export enum LinkedEntityType {
  DATA_VENDOR = 'DATA_VENDOR',
  DATASET = 'DATASET',
  CONTACT = 'CONTACT',
}
